import Vue from 'vue';
import Vuex from 'vuex';
import { getField, updateField } from 'vuex-map-fields';
Vue.use(Vuex);

/// /// STORE /////////////////////////////////////////

const state = {
    // API
    domainName: '',
    whiteLabelling: {},

    isAuthenticated: false,
    jwt: null,
    keepJwtUp: null,

    user: null,
    consent: null,
};

// mutations are operations that actually mutates the state.
// each mutation handler gets the entire state tree as the
// first argument, followed by additional payload arguments.
// mutations must be synchronous and can be recorded by plugins
// for debugging purposes.
const mutations = {
    updateField,
    setDomainName(state, domainName) {
        Vue.set(state, 'domainName', domainName);
    },
    setWhiteLabelling(state, data) {
        Vue.set(state, 'whiteLabelling', data);
    },
    setAuthUser(state, { user, isAuthenticated }) {
        Vue.set(state, 'user', user);
        Vue.set(state, 'isAuthenticated', isAuthenticated);
    },
    // update JWT information
    updateToken(state, newToken) {
        localStorage.setItem('token', newToken);
        state.jwt = newToken;
        state.isAuthenticated = true;
    },
    refreshTokenFunction(state, func) {
        state.keepJwtUp = func;
    },
    // Remove JWT
    removeToken(state) {
        localStorage.removeItem('token');
        state.jwt = null;
        state.user = null;
        state.isAuthenticated = false;
        state.keepJwtUp = null;
    },
    // update user profile
    // updateProfile(state, profile) {
    //     Vue.set(state, 'userProfile', profile)
    // },
    // update user consent
    // updateConsent(state, consent) {
    //     state.consent = consent;
    // },
    // update user profile and consent
    updateProfileAndConsent(state, data) {
        Vue.set(state, 'user', data.user);
        Vue.set(state, 'consent', data.rgpd_consent);
    },
    updateProfilePic(state, data) {
        let user = state.user;
        // eslint-disable-next-line camelcase
        user.profile_pic = data.profile_pic;
        Vue.set(state, 'user', user);
    },
};

// actions are functions that cause side effects and can involve
// asynchronous operations.
const actions = {};

// getters are functions
const getters = {
    getField,
};

export const store = new Vuex.Store({
    state,
    getters,
    actions,
    mutations,
    strict: process.env.NODE_ENV !== 'production',
});

/// /// /STORE /////////////////////////////////////////
